var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFormatColorTextEdit = function SvgFormatColorTextEdit(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 19L11 5H13L15.2887 10.8365L13.7639 12.3614L12 7.67L9.62 14H12.1253L10.1253 16H8.87L7.75 19H5.5ZM13.8747 16H14.1253L16.4155 13.7098L16.3449 13.5298L13.8747 16ZM17.4716 16.4031L15.8689 18.0059L16.24 19H18.49L17.4716 16.4031Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.1253V19H12.8747L18.404 13.4708L16.5292 11.596L11 17.1253ZM19.8538 12.021C20.0487 11.826 20.0487 11.511 19.8538 11.3161L18.6839 10.1462C18.489 9.95126 18.174 9.95126 17.979 10.1462L17.0642 11.0611L18.9389 12.9358L19.8538 12.021Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFormatColorTextEdit);
export { ForwardRef as ReactComponent };